function HelperText({ children }) {
    return (
        <div className="text-sm text-olm-gray my-1 flex flex-row gap-1">
            {/* <InformationCircleIcon className="w-5 h-5" /> */}
            <p>{children}</p>
        </div>
    )
}

export default HelperText
